import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { ZoomOutNotifier } from './zoom-out-notifier';
import { ZoomOutState } from './zoom-out-state';

@Injectable()
export class ZoomOutProvider extends BaseProvider<ZoomOutNotifier, ZoomOutState> {
  constructor() {
    super(ZoomOutNotifier);
  }
}
